/**
 * @title navigation_v2.js: Feature level module
 * @description The module used for redesigned 'navigation'
 * feature which encapsulates 'navigation'.
 * 
 */
define([], function() {

  let Navigation_v2 = {

    maxLevel: 4,
    maxPhoneLevel: 3,
    navigationData: '#navigation_v2_data',
    navigationUI: '#navigation-v2-category-container',
    navigationPhoneUI: '#navigation-v2-category-container-phone',
    navigationCategoryLevel: '.navigation-category-level',
    level: '#level',
    level1_AllDepartments: '#level1-all-departments',
    level1_AncillaryDepartments: '#level1-ancillary-departments',
    level2_AllDepartments: '#level2-all-departments',
    level2_AncillaryDepartments: '#level2-ancillary-departments',
    navigationContainerPhone: '#navigation-v2-category-container-phone',
    menuIconDesktop: '#navigation-dropdown',
    nextFocusElementClosedMenu: '#Home_Ancillary_0',
    menuIconMobile: '#shop-mt-mobile',
    firstSubcategoryElement: '',
    lastSubcategoryElement: '',
    lastAllDepartmentsElementTablet: '',
    allDepartmentsParentId: '',
    closeMenuButtonHTML: '<li class="cds-u-space-pb-md"><a id="close-menu-button" href="#"><input type="button" class="btn btn-primary" value="' + messages.CLOSE_MENU + '"/></a></li>',
    KEYCODES: {
    	TAB_KEY: 9,
    	ESC_KEY: 27,
    	ENTER_KEY: 13,
    	RIGHT_ARROW_KEY: 39,
    	KEYDOWN_EVENT: 1
    },
    tempFragment: document.createDocumentFragment(),

    init : function() {
      Navigation_v2.$navigationWidgetEle = $('#navigation-widget');
      let $navigationDataEle = $('#navigation_v2_data');
      Navigation_v2.$navigationDataUL = $($navigationDataEle.prop('nodeName') === 'NOSCRIPT' ? $navigationDataEle.text() : $navigationDataEle.html());
    	
      if (Navigation_v2.$navigationWidgetEle.length > 0) {	
       	Navigation_v2.initializeMegaMenuForDesktopView();
        Navigation_v2.initializeMegaMenuForMobileView();
        Navigation_v2.setMegaMenuOverlay();
        Navigation_v2.bindMegaMenuFocusEvents();

        //populate navigation data with category-level-2 and category level-3 links from corresponding espots
        Navigation_v2.$navigationDataUL.find('[data-parent="0"]').each( function() {
          let topCategoryId = $(this).attr('data-id');
          let $espotParentEle = Navigation_v2.$navigationDataUL.find('[data-espot-parent="' + topCategoryId +'"]');
          if ($espotParentEle.find('.category-level-2').length !== 0) {
            Navigation_v2.populateNavigationDataWithEspotSubcategoryLinks(topCategoryId);
          }
        });

        //extracting ancillary subcategory links from espots for phone view
        if (Navigation_v2.isPhoneView()) {
          $('#level2-phone').empty(); 
          $('#level3-phone').empty();
          Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"]').each( function() {
            let topCategoryId = $(this).attr('data-id');
            Navigation_v2.populateAncillaryNavigationDataWithEspotSubcategoryLinks(topCategoryId);
          });
          }

        // append extracted all subcategory links from espots at once to the parent <ul></ul>
        if(Navigation_v2.tempFragment.childNodes.length) {
          Navigation_v2.$navigationDataUL.append(Navigation_v2.tempFragment);
          $('#navigation_v2_data').empty().append(Navigation_v2.$navigationDataUL);
        }
        
        if ($('#isBDAppVar').val() == 'BD') {
            Navigation_v2.nextFocusElementClosedMenu = '#Home_Ancillary_1';
        }

        // Nav popovers are required for Ancillary links that are part #navigation-widget which is shown only when VW is greater than 1024px
        // Hence we do not need to initialize nav popovers for phone and tablet view
        if (!Navigation_v2.isPhoneView() && !Navigation_v2.isTabletView()) {
          Navigation_v2.initNavPopovers();
        }

        console.log("navigation_v2.js module loaded.");
      }
    },

    /**
     *  This method is called on each tab key and (shift + tab) key press when menu icon is focused or
     *  when focus is on navigation panel. Method switch focus by defined rules for Desktop
     *  and Tablet view.
     *
     *  @param event
     *
     * */
    navigationFocusControl: function(event) {
    	let level = Navigation_v2.checkAndSetLevelFirstAndLastElement();
    	let firstSubcategoryElement = Navigation_v2.firstSubcategoryElement;
    	let lastSubcategoryElement = Navigation_v2.lastSubcategoryElement;
    	let menuIconDesktop = Navigation_v2.menuIconDesktop;
    	let nextFocusElementClosedMenu = Navigation_v2.nextFocusElementClosedMenu;

    	// Shift + tab combination returns focus and check if first category link is selected
    	// if it is first level it focus the 'shop all departments' button on other return focus parent category
    	// and closes the higher level.
    	if (event.shiftKey){
	 		if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
 				if ($(document.activeElement).is(firstSubcategoryElement)) {
		 			event.preventDefault();
		 			if (level === 1) {
            //This is needed because we dont want to trigger extra shift + tab event which is already getting fired from react Mui component
            isEventFromReact = Array.from(event.target.classList).some(className => className.startsWith('Mui'));
            if(!isEventFromReact) {
              if(Navigation_v2.isTabletView()) {
                $(Navigation_v2.menuIconMobile).focus();
                Navigation_v2.hideOverlayAndCloseMenu(false);
              } else {
                $(menuIconDesktop).focus();
              }
            }
		 			} else if (level === 2 || level === 3) {
		 				Navigation_v2.selectSubcategoryParentLink(Navigation_v2.returnParentCategoryId(firstSubcategoryElement, "firstElement"));
		 			}
		 		}
	 		}
	 	} else if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	 		// Tab key set focus on next element. If it is last element on first level it closes the menu and shift focus to
	 		// grocery link. On higher levels when focus reach last element next tab will shift focus to the next element
	 		// below parent category and will close the higher level.

      if ($(document.activeElement).is(lastSubcategoryElement)) {
         //prevent default doesnt let it focus correctly on espots when Mega menu react component is used
         // but we also want to prevent default if we are are on level 1
        if(!isGRSMegaMenuEnabled || level === 1) {
          event.preventDefault();
        }
        if (level === 1) {		
          Navigation_v2.hideOverlayAndCloseMenu(false);
          $(nextFocusElementClosedMenu).focus();
        } else if (level === 2 || level === 3) {
          $($('#'+Navigation_v2.returnParentCategoryId(lastSubcategoryElement, "lastElement"))).next().find('a').focus();
        }
      }
	 	}
   	},

   	/**
   	 *  This method check what level is currently active and set first and last element
   	 *  appropriately. Used for desktop and tabled view.
     *
     *  Sets Navigation_v2 variables firstSubcategoryElement and lastSubcategoryElement.
     *
     *  @return number of level currently active
     * 
     * */
   	checkAndSetLevelFirstAndLastElement: function() {
    	let level = 0;
    	let levelSelector = '';
    	// We check what level is current focus on so we can select proper first and last elements
    	// that are used as starting and ending point for focus switching.
    	if ($('#level1-all-departments').is(':visible') && $('#level2').is(':hidden') && $('#level3').is(':hidden')) {
    		// For first level there are ancillary elements too so we need to use level1-phone and not
    		// level1-all-departments-phone since it holds only category elements.
    		if (Navigation_v2.isTabletView()){
    			levelSelector = '#level1';
    		} else {
    			levelSelector = '#level1-all-departments';
    		}
    		
			level = 1;
		} else if ($('#level2').is(':visible') && $('#level3').is(':hidden')) {
			levelSelector = '#level2';
	    	level = 2;
		} else if ($('#level3').is(':visible')) {
			levelSelector = '#level3';
	    	level = 3;
	    }

    	Navigation_v2.firstSubcategoryElement = $(levelSelector).find('li a').first();
    	Navigation_v2.lastSubcategoryElement = $(levelSelector).find('li').last();

    	if(Navigation_v2.categoryHasChildData(Navigation_v2.lastSubcategoryElement.attr('id'))) {
      		Navigation_v2.lastSubcategoryElement = $('#arrow-' + Navigation_v2.lastSubcategoryElement.attr('id'));
   		} else {
   			Navigation_v2.lastSubcategoryElement = $(Navigation_v2.lastSubcategoryElement.find('a'));
   		}

    	return level;
    },

    returnParentCategoryId: function(element, elementPosition) {
    	return elementPosition === "firstElement" ? $(element).parent().parent().attr('data-parent') : $(element).parent().attr('data-parent');
    },

    /**
     *  This method is called on each tab and (shift + tab) key press when menu icon is focused or
     *  when focus is on navigation panel. Method switch focus by defined rules for Phone view.
     *
     *  @param event
     * 
     * */
    navigationFocusControlPhone: function(event) {
		let level = Navigation_v2.checkAndSetLevelFirstAndLastElementPhone();
    	let firstSubcategoryElement = Navigation_v2.firstSubcategoryElement;
    	let lastSubcategoryElement = Navigation_v2.lastSubcategoryElement;
    	let backToParentCategoryButton = $('#level1-phone').children('li').eq(1);
    	let backToAllCategoriesButton = $('#level1-phone').find('li').first();
    	let nextFocusElementClosedMenu = Navigation_v2.nextFocusElementClosedMenu;
    	let navigationContainerPhone = $(Navigation_v2.navigationContainerPhone).is(':visible')
    	
    	$(Navigation_v2.menuIconMobile).attr('aria-expanded', 'true');
    	if (event.shiftKey) {
	 		if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
	 			// This is executes when shift + tab combination is pressed.
	 			// First should check if it is first element in subcategory is selected.
	 			if ($(document.activeElement).is(firstSubcategoryElement)) {
	 				// On first level there is no back buttons(links) so focus should go to menu icon.
	 				if (level === 1) {
						event.preventDefault();
						Navigation_v2.hideOverlayAndCloseMenu(true);
						Navigation_v2.setFocusOnMenuIcon();
		         	} else if (level === 2){
		         		// On second level there is only back to all categories button(link) so focus should go
		         		//to 'back to all categories button'
		         		event.preventDefault();
		         		backToAllCategoriesButton.focus();
		         	} else if (level === 3) {
		         		// On third level there are 'back to all categories button' and 'back to parent category button'
		         		// so focus should go to first of those two which is 'back to parent category button'.
		         		event.preventDefault();
		         		backToParentCategoryButton.focus();
		         	}
	 			} else if ($(document.activeElement).is(backToAllCategoriesButton)) {
	 				// If focus is not on first category element then we check if it is on
	 				// 'back to all categories button' or 'back to parent category button' if it is level 3.
	 				event.preventDefault();
	 				Navigation_v2.setFocusOnMenuIcon();
	 			} else if (level === 3) {
	 				if ($(document.activeElement).is(backToParentCategoryButton)) {
	 					event.preventDefault();
	 					backToAllCategoriesButton.focus();
	 				}
	 			}
	 		}
   		} else if (event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
   			// This executes on Tab keypress
   			if ($(document.activeElement).is(lastSubcategoryElement) ||
   					($(document.activeElement).is($(Navigation_v2.menuIconMobile)) && navigationContainerPhone == true )) {
   				// Condition cover case scenario where menu is already open but focus is on last element or on menu icon in both cases
   				event.preventDefault();
				// If level is first then we select first link since on first level there is no back to all categories button
				if (level === 1) {
					Navigation_v2.hideOverlayAndCloseMenu(false);
	 				$(nextFocusElementClosedMenu).focus();
				} else {
					backToAllCategoriesButton.focus();
	 			}
	 		} else if (level === 3) {
	 			// If level is third one and none of the above cases is met focus is
	 			// set manually from 'back to all categories button' to 'back to parent category button'
	 			// Also if 'back to parent category button' is focused then we need to move focus to 'first subcategory element'.
	 			if ($(document.activeElement).is(backToAllCategoriesButton)) {
		 			event.preventDefault();
		 			backToParentCategoryButton.focus();
	 			} else if ($(document.activeElement).is(backToParentCategoryButton)) {
	 				event.preventDefault();
	 				$(firstSubcategoryElement).focus();
	 			}
	 		}
   		}
    },

    setFocusOnMenuIcon: function() {
    	$(Navigation_v2.menuIconMobile).focus();
    },

    /**
   	 *  This method check what level is currently active and set first and last element
   	 *  appropriately. Used for phone view.
     *
     *  Sets Navigation_v2 variables firstSubcategoryElement and lastSubcategoryElement.
     *
     *  @return number of level currently active
     *
     * */
    checkAndSetLevelFirstAndLastElementPhone: function() {
    	let level = 0;
    	let levelSelector = '';
    	// We check what level is current focus on so we can select proper first and last elements
    	// that are used as starting and ending point for focus switching.
    	if ($('#level1-all-departments-phone').is(':visible')) {
    		// For first level there are ancillary elements too so we need to use level1-phone and not
    		// level1-all-departments-phone since it holds only category elements.
    		levelSelector = '#level1-phone';
			level = 1;
		} else if ($('#level2-phone').is(':visible')) {
			levelSelector = '#level2-phone';
	    	level = 2;
		} else if ($('#level3-phone').is(':visible')) {
			levelSelector = '#level3-phone';
	    	level = 3;
	    }

    	if (levelSelector == '#level1-phone') {
	    	 Navigation_v2.firstSubcategoryElement = $('#level1-all-departments-phone').find('li a').first();
	    } else {
	    	 Navigation_v2.firstSubcategoryElement = $(levelSelector).find('a').first();
	    }

    	Navigation_v2.lastSubcategoryElement = $(levelSelector).find('li a').last();

    	return level;
    },

    bindMegaMenuFocusEvents: function() {

    	if(Navigation_v2.isTabletView() || Navigation_v2.isPhoneView()) {
    		Navigation_v2.nextFocusElementClosedMenu = '#search-field';
		}

    	$('#navigation-v2-category-container,'+ Navigation_v2.menuIconDesktop+', '+ Navigation_v2.menuIconMobile).keydown(function (event) {
    		// If we don't check if navigation container is visible then focus
    		// will stop on menu icon when container is closed.
     		 if (event.which === Navigation_v2.KEYCODES.TAB_KEY && $('#navigation-v2-category-container').is(':visible')) {
     			 COSTCO.Navigation_v2.navigationFocusControl(event);
     	 	 }
    	});

    	$('#navigation-v2-category-container-phone,'+ Navigation_v2.menuIconMobile).keydown(function (event) {
    		// If we don't check if navigation container is visible then focus
    		// will stop on menu icon when container is closed.
     		 if (event.which === Navigation_v2.KEYCODES.TAB_KEY && $('#navigation-v2-category-container-phone').is(':visible')) {
     			 if(COSTCO.Navigation_v2.isPhoneView()) {
    				 COSTCO.Navigation_v2.navigationFocusControlPhone(event);
     			 }
     		 }
    	});


      $("#level1-ancillary-departments-phone").click(function() {
             window.scrollTo({top: 0, behavior: "smooth"});
         });
    },

    initializeMegaMenuForDesktopView: function() {
      $(Navigation_v2.menuIconDesktop).on('keydown click', function(event) {
    	  // Key down event for Enter key
    	  if (event.which === Navigation_v2.KEYCODES.ENTER_KEY) {
    		  event.preventDefault();
    	  }
    	  if ((event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.which === Navigation_v2.KEYCODES.KEYDOWN_EVENT) && event.which !== Navigation_v2.KEYCODES.TAB_KEY ) {
		      Navigation_v2.toggleNavigation(false, event);
		      $(Navigation_v2.menuIconDesktop).attr('aria-expanded', 'true');
		  }
      });
      $(Navigation_v2.menuIconDesktop).on('focus', function(event) {
    	  Navigation_v2.hideOverlayAndCloseMenu(false);
      });
      $(Navigation_v2.menuIconDesktop).on('mouseenter', function(event) {
      	  if (typeof isJQueryUpgraded  != 'undefined' && isJQueryUpgraded) {
    		  if (event.target.id.length > 0) {
    			  Navigation_v2.menuIconDesktopMouseEnterDef(event);
    		  }
    	  } else {
    		  Navigation_v2.menuIconDesktopMouseEnterDef(event);
    	  }
      }).on('mouseleave', function(event) {
    	  if (typeof isJQueryUpgraded  != 'undefined' && isJQueryUpgraded) {
    		  if (event.target.id.length > 0) {
        		  Navigation_v2.menuIconDesktopMouseLeaveDef(event);
    		  }
    	  } else {
    		  Navigation_v2.menuIconDesktopMouseLeaveDef(event);
    	  }
      });
    },

    menuIconDesktopMouseLeaveDef: function(event) {
		let timerId = $('#' + event.target.id).data('timerId');
        if (timerId != null) {
          clearTimeout(timerId);
        }
    },
    
    menuIconDesktopMouseEnterDef: function(event) {
        let hoveredElement = $('#' + event.target.id);
        let timer = setTimeout(function() {
          hoveredElement.data('timerId', null);
          if (hoveredElement.attr('id') !== undefined && hoveredElement.attr('id') !== false ) {
            Navigation_v2.toggleNavigation(false, event);
            $(Navigation_v2.menuIconDesktop).attr('aria-expanded', 'true');
          }
          Navigation_v2.toggleSubCategoryElements(false);
        },300);
        hoveredElement.data('timerId', timer);
    },
    
    initializeMegaMenuForMobileView: function() {
      $(Navigation_v2.menuIconMobile).attr('aria-expanded', 'false');
      $(Navigation_v2.menuIconMobile).on('click', function(event) {
        if (Navigation_v2.isPhoneView()) {
          Navigation_v2.toggleNavigation(true, event);
        } else {
          Navigation_v2.toggleNavigation(false, event);
        }
      });
    },

    setMegaMenuOverlay: function() {
      if(Navigation_v2.isPhoneView()) {
        $(document.documentElement).on('touchstart mousedown',
          function(e) {
            var userDropdownArea = $(Navigation_v2.menuIconMobile + ", " + Navigation_v2.navigationPhoneUI);
            var target = $(e.target);
            if(!userDropdownArea.is(target) && userDropdownArea.has(target).length === 0) {
              Navigation_v2.hideOverlayAndCloseMenu(true);
            }
          }
        );
      } else {
        $(document.documentElement).on('mousedown',
          function(e) {
            var userDropdownArea = $("#navigation-dropdown, .navigation-category-level, .navigation");
            var target = $(e.target);
            if(!userDropdownArea.is(target) && userDropdownArea.has(target).length === 0) {
              Navigation_v2.hideOverlayAndCloseMenu(false);
            }
          }
        );

        $('.nav-item:not(#navigation-dropdown), .top-links',  Navigation_v2.$navigationWidgetEle.add('#header-widget')).on('mouseenter', function(event) {
            let hoveredElement = $(event.target);
            let timer = setTimeout(function() {
              hoveredElement.data('timerId', null);
              if (hoveredElement !== undefined && hoveredElement !== false ) {
                 Navigation_v2.hideOverlayAndCloseMenu(false);
              }
            },500);
            hoveredElement.data('timerId', timer)
          }).on('mouseleave', function(event) {
            let timerId = $(event.target).data('timerId');
            if (timerId != null) {
              clearTimeout(timerId);
            }
          });
      }
    },

    isPhoneView: function() {
      return $(window).width() <= 667;
    },
    
    isTabletView: function() {
      return $(window).width() <= 1024 && !Navigation_v2.isPhoneView();
    },

    toggleNavigation: function(isPhone, event) {
      
      event.preventDefault();
      let elementPanel = isPhone ? Navigation_v2.navigationPhoneUI : Navigation_v2.navigationUI;
      if(isGRSMegaMenuEnabled) {
        $(elementPanel).children().first().children().css('display', '');
      }
      if ($(elementPanel).is(':visible')) {
        Navigation_v2.hideOverlayAndCloseMenu(isPhone);
      } else {
        Navigation_v2.fillTopCategoryData(isPhone);
        if (isPhone) {
          Navigation_v2.bindPhoneChildCategories(1);
        } else { 
          Navigation_v2.bindChildCategories(1);
        }
        Navigation_v2.showOverlayWhenMenuDisplayed();
        Navigation_v2.toggleSubCategoryElements(isPhone);
        $(elementPanel).show();
        if (event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.which === Navigation_v2.KEYCODES.KEYDOWN_EVENT) {
        	if($(event.target).is('#navigation-dropdown')) {
        		 Navigation_v2.selectFirstElementInCategory(1, false);
        	} else if($(event.target).is('#shop-mt-mobile')) {
        		 $(Navigation_v2.menuIconMobile).attr('aria-expanded', 'true');
        		 if(Navigation_v2.isPhoneView()) {
        			 Navigation_v2.selectFirstElementInCategory(1, true);
        		 } else {
        			 Navigation_v2.selectFirstElementInCategory(1, false);
        		 }
        	}
        }  
      }
    },

    selectFirstElementInCategory: function(level, isPhone) {
      let phoneSufix = isPhone ? '-phone' : '';
      if(isPhone) {
    	  $(Navigation_v2.level + level + phoneSufix).find('li a').first().focus();
      } else {
    	  $(Navigation_v2.level + level).find('li a').first().focus();
      }
    },

    selectSubcategoryParentLink: function(parentId) {
      $('#' + parentId + ' a').focus();
    },

    fillTopCategoryData: function(isPhone) {
      let phoneSufix = isPhone ? '-phone' : '';
      let allDepartmentsParentData = Navigation_v2.$navigationDataUL.find('[data-parent="0"]').clone();
      Navigation_v2.addIdAttributeToElements(allDepartmentsParentData);

      let ancillaryDepartmentsData = wcs.isPharmacy === "true" ? Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"][data-id^="RX_Home_Ancillary"]').clone() : 
        Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"][data-id^="Home_Ancillary"]').clone();

      Navigation_v2.addIdAttributeToElements(ancillaryDepartmentsData);

      $(Navigation_v2.level1_AllDepartments + phoneSufix).find('ul').append(allDepartmentsParentData);
      $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).append(ancillaryDepartmentsData);

      if (isPhone) {
        $(Navigation_v2.level1_AllDepartments + phoneSufix).each( function() {
          $(Navigation_v2.level1_AllDepartments + phoneSufix + ' a').removeAttr('href');
        });
        $(Navigation_v2.level1_AncillaryDepartments + phoneSufix + ' li').each( function() {
          let parentLiElementId = $(this).attr('data-id') !== undefined && $(this).attr('data-id') !== false ? $(this).attr('data-id') : $(this).attr('id');
          if (Navigation_v2.categoryHasChildData(parentLiElementId)) {
            $(this).find('a').each(function() {
              $(this).removeAttr('href');
            })
          }
        });
      }
    },

    addIdAttributeToElements: function(elements) {
      elements.each( function() {
        let dataIdAttribute = $(this).attr('data-id');
        $(this).attr('id', dataIdAttribute);
        $(this).removeAttr('data-id');
      })
    },

    bindChildCategories: function(level) {
    
    	if (Navigation_v2.isTabletView()) {
        if ($('#level1-ancillary-departments').find('#close-menu-button').length === 0) {
            $('#level1-ancillary-departments').append(Navigation_v2.closeMenuButtonHTML);
        }    		
    		Navigation_v2.bindCloseMenuEvent(false);
    	}
    	
       $(Navigation_v2.level + level + ' li').hover(
            (event)=> Navigation_v2.bindChildElementOnHover(event, level),
            (event)=> Navigation_v2.unbindChildElementOnHover(event)
        );

        $(Navigation_v2.level + level + ' li a').on('focus', function(event) {
          if ($(event.target.parentElement).attr('id') !== undefined && $(event.target.parentElement).attr('id') !== false ) {
            Navigation_v2.emptySubCategoryElements(level + 1, false);
            Navigation_v2.bindChildElementOnKeyboardNavigation(event, level);
            Navigation_v2.toggleSubCategoryElements(false);
          } else if ($(event.target.parentElement).attr('data-id') !== undefined && $(event.target.parentElement).attr('data-id') !== false) {
            let dataParentId = $(event.target.parentElement).attr('data-id');
            $(Navigation_v2.level + level).find('li[data-parent="' + dataParentId + '"]').each(function() {
              $(this).removeClass('selectedLinkBold');
            })
          }
        });
    },

    bindChildElementOnHover: function(event, level) {
    	if(typeof isJQueryUpgraded  != 'undefined' && isJQueryUpgraded){
	    	if(event.target.id.length > 0){
	    		Navigation_v2.bindChildElementOnHoverDef(event, level);
	    	}
    	} else {
    		Navigation_v2.bindChildElementOnHoverDef(event, level);
    	}
    },

    bindChildElementOnHoverDef: function(event, level) {
        let hoveredElement = $('#' + event.target.id);
        let hoveredElementId = event.target.id;
        let parentId = hoveredElement.attr('data-parent');
        let isAncillary = Navigation_v2.isAncillaryElementSelected(hoveredElementId);

        Navigation_v2.keepParentLinksHighlighted(level, hoveredElement.attr('id'));
        Navigation_v2.removeChevronFromAllLinks();

        if ( level < Navigation_v2.maxLevel - 1) {
          if(isGRSMegaMenuEnabled && level == 2) {
            //skip the execution of below block if this condition is met
            //we dont want to fill empty subcategories because they are now coming from react component.
          }
          else {
            let timer = setTimeout(function() {
              hoveredElement.data('timerId', null);
              if (hoveredElement.attr('id') !== undefined && hoveredElement.attr('id') !== false ) {
                Navigation_v2.fillChildData(level + 1, hoveredElement.attr('id'), isAncillary);
              }
              Navigation_v2.toggleSubCategoryElements(false);

            },300);          
            hoveredElement.data('timerId', timer);
          }
        }
    },
    
    unbindChildElementOnHover: function(event) {
    	if(typeof isJQueryUpgraded  != 'undefined' && isJQueryUpgraded){
    		if(event.target.id.length > 0){
    			Navigation_v2.unbindChildElementOnHoverDef(event);
    		}
        } else {
        	Navigation_v2.unbindChildElementOnHoverDef(event);
        }
    },

    unbindChildElementOnHoverDef: function(event){
        let timerId = $('#' + event.target.id).data('timerId');
        if (timerId != null) {
          clearTimeout(timerId);
        }
     },
    
    bindChildElementOnClick: function(event, level) {
  	  if(event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.type == 'click') {	
		  if(typeof isJQueryUpgraded  != 'undefined' && isJQueryUpgraded){
			  if(event.target.id.length > 0){
				  Navigation_v2.bindChildElementOnClickDef(event, level);
			  }
		  } else {
			  Navigation_v2.bindChildElementOnClickDef(event, level);
		  }
	   }
    },

    bindChildElementOnClickDef: function(event, level) {
        let clickedElement = $('#' + event.target.id);
  	  let clickedElementId = event.target.id;
  	  let parentId = clickedElement.attr('data-parent');
  	  let isAncillary = Navigation_v2.isAncillaryElementSelected(clickedElementId);
  	
  	  Navigation_v2.keepParentLinksHighlighted(level, clickedElement.attr('id'));
  	  Navigation_v2.removeChevronFromAllLinks();
  	
  	  if ( level < Navigation_v2.maxLevel - 1) {
  	    if (clickedElement.attr('id') !== undefined && clickedElement.attr('id') !== false ) {
  	    	Navigation_v2.fillChildData(level + 1, clickedElement.attr('id'), isAncillary);
  	    }
  	
  	    clickedElement.find('a').attr('aria-expanded', 'true');
  	
  	  	Navigation_v2.toggleSubCategoryElements(false);
        }
    },
    
    bindChildElementOnKeyboardNavigation: function(event, level) {
      let parentLiElement = $(event.target.parentElement);
      let parentLiElementId = parentLiElement.attr('data-id') !== undefined && parentLiElement.attr('data-id') !== false ? parentLiElement.attr('data-id') : parentLiElement.attr('id');
      let parentId = parentLiElement.attr('data-parent');
      let isAncillary = Navigation_v2.isAncillaryElementSelected(parentLiElementId);

      Navigation_v2.keepParentLinksHighlighted(level, parentLiElementId);
      Navigation_v2.removeChevronFromAllLinks();

      if (isGRSMegaMenuEnabled || Navigation_v2.categoryHasChildData(parentLiElementId)) {
        Navigation_v2.addChevronForSelectedLink(parentLiElement);
      }
      
      $(Navigation_v2.level + level + ' li  a, li  i').on('click keydown', function(event) {
        let parentLiElementId = ($(event.target).is('a') || $(event.target).is('i')) ? $(event.target.parentElement).attr('id') : $(event.target.parentElement.parentElement).attr('id') ;
        let categoryParentId =  $('#' + parentLiElementId).attr('data-parent');
        if (event.which === Navigation_v2.KEYCODES.ESC_KEY) {
          Navigation_v2.closeMenuLevelPanelOnEcs(categoryParentId, level);
        } else if ($(event.target).is('a') && event.which === Navigation_v2.KEYCODES.RIGHT_ARROW_KEY) {
          Navigation_v2.openSubcategoryOnRightArrow(parentLiElementId, level, isAncillary);
          $('#' + parentLiElementId).find('a').attr('aria-expanded', 'true');
          if(isGRSMegaMenuEnabled) {
            // Accessibility feature - fetch subcategories for the selected top category from the react component.
            let topLevelCategory;
            if(event.target.nextElementSibling) {
              topLevelCategory = event.target.nextElementSibling.parentElement
            }
            if (topLevelCategory && window.openSubCategoriesFromElement) {
              window.openSubCategoriesFromElement(topLevelCategory, true);
            }
          }
          // when screen reader is active target is set to child span element
        } else if (($(event.target).is('button') || $(event.target).is('i')) && ((event.which === Navigation_v2.KEYCODES.ENTER_KEY) || (event.which === Navigation_v2.KEYCODES.KEYDOWN_EVENT))) {
          event.preventDefault();
          Navigation_v2.toggleSubCategoryElements(false);
          Navigation_v2.openSubcategoryOnEnter(parentLiElementId, level, isAncillary);
          $('#' + parentLiElementId).find('a').attr('aria-expanded', 'true');
          
          if(isGRSMegaMenuEnabled) {
            // Accessibility feature - fetch subcategories for the selected top category from react component
            let topLevelCategory;
            if($(event.target).is('i')) {
              topLevelCategory = event.target.parentElement;
            }else if($(event.target).is('button')) {
              topLevelCategory = event.target.parentElement.parentElement;
            }
            if (topLevelCategory && window.openSubCategoriesFromElement) {
              window.openSubCategoriesFromElement(topLevelCategory, true);
            }
          }
        }
      });
    },

    closeMenuLevelPanelOnEcs: function (parentId, level) {
      if (level == 1) {
        Navigation_v2.hideOverlayAndCloseMenu(false);
        $('#navigation-dropdown').focus();
      } else {
        Navigation_v2.emptySubCategoryElements(level, false);
        Navigation_v2.selectSubcategoryParentLink(parentId);
      }
      //change aria-expanded attribute to false
      if ($('#arrow-' + parentId) !== undefined) {
        $('#arrow-' + parentId).attr('aria-expanded', 'false');
      }
      if ($('#span-' + parentId) !== undefined) {
        $('#span-' + parentId).attr('aria-expanded', 'false');
      }
     if ($('#' + parentId).find('a') !== undefined) {
    	$('#' + parentId).find('a').attr('aria-expanded', 'false'); 
     }
      
    },

    openSubcategoryOnEnter: function(parentLiElementId, level, isAncillary) {
      if (level < Navigation_v2.maxLevel - 1) {
        Navigation_v2.openSubcategoryOnKeyup(level, parentLiElementId, isAncillary);
      }
    },

    openSubcategoryOnRightArrow: function(parentLiElementId, level, isAncillary) {
      if (level < Navigation_v2.maxLevel - 1) {
        Navigation_v2.openSubcategoryOnKeyup(level, parentLiElementId, isAncillary);
      }
    },

    openSubcategoryOnKeyup: function(level, elementId, isAncillary) {
      Navigation_v2.fillChildData(level + 1, elementId, isAncillary);
      Navigation_v2.toggleSubCategoryElements(false);
      Navigation_v2.selectFirstElementInCategory(level + 1);
    },

    bindPhoneChildCategories: function(level) {
      let phoneSufix = '-phone';
      let parentElementId = Navigation_v2.level + level + phoneSufix;

      $(Navigation_v2.level + level + phoneSufix).find('li').each( function() {
    	  if(level == 1 && $(this).text().trim() != messages.NAV_LOCATIONS) {
    		  $(this).find('a').attr("href","#");
    	  }
    	  if(!Navigation_v2.categoryHasChildData($(this).attr('id'))) {
          $(this).find('a').addClass('clickable-link');
        }
      });

      $(parentElementId + ' li').on('click keydown', function(e) {
          if(e.which === Navigation_v2.KEYCODES.ENTER_KEY || e.type == 'click') {
            if(isGRSMegaMenuEnabled) {
              let topLevelCategory;
              if($(e.target).is('a')) {
                topLevelCategory = e.target.parentElement;
                if (topLevelCategory && window.openSubCategoriesFromElement) {
                  window.openSubCategoriesFromElement(topLevelCategory, true);
                }
              }
            }
            else {
              let id = this.id;
              let parentId = $(this).attr('data-parent');
              if( Navigation_v2.categoryHasChildData(id)) {
                  Navigation_v2.emptySubCategoryElements(1);
                  Navigation_v2.addSubcategoryTitle(this.innerText);
                  if(level > 1) {
                    Navigation_v2.addParentSubcategoryLink(parentId);
                      Navigation_v2.addAllDepartmentsLink(parentId);
                  } else {
                    Navigation_v2.addAllDepartmentsLink(id);
                  }
                
                  if(e.which === Navigation_v2.KEYCODES.ENTER_KEY) {
                    $('#all-departments-link').focus();
                  }
                Navigation_v2.fillPhoneChildData(level + 1, id);
              }
            }
    	    }
      });
      
      let selector = '';
      if (level === 1){
    	  selector = '#level1-ancillary-departments-phone';
      } else {
    	  selector = parentElementId;
      }
      $(selector).append(Navigation_v2.closeMenuButtonHTML);
      Navigation_v2.bindCloseMenuEvent(true);
    },
    
    /**
     * Due to screenreader focus issue for mobile users new close menu button 
     * is added. This bind event is added to that button to close the menu on mobile devices. 
     * @param isPhone parameter to check is device actually phone screen size. 
     * @return {void}
     * 
     * */
    bindCloseMenuEvent: function(isPhone) {
    	let closeMenuSelector = '#close-menu-button';
    	$(closeMenuSelector).on('keydown click' , function(e) { 
         	e.preventDefault();
     	    COSTCO.Navigation_v2.hideOverlayAndCloseMenu(isPhone);
          //Move the focus back to shop menu button
          Navigation_v2.setFocusOnMenuIcon();
        });
    },

    categoryHasChildData: function(parentId) {
      return (Navigation_v2.$navigationDataUL.find('[data-parent=' + parentId + ']').length !== 0)
          || (Navigation_v2.$navigationDataUL.find('[data-espot-parent=' + parentId + ']').length !== 0);
    },

    fillChildData: function(level, parentId, isAncillary) {
      for (i = level; i <= Navigation_v2.maxLevel; i++) {
        if (i == 2) {
          $(Navigation_v2.level2_AllDepartments).find('ul').empty();
          $(Navigation_v2.level2_AncillaryDepartments).empty();
        } else {
          $(Navigation_v2.level + i).find('ul').empty();
        }
      }
      if (isAncillary) {
        Navigation_v2.showTopCatEspot(parentId, isAncillary);
      } else {
        let childElements = Navigation_v2.$navigationDataUL.find('[data-parent=' + parentId + ']').clone();
        Navigation_v2.addIdAttributeToElements(childElements);
        let subcategoryTitle = Navigation_v2.$navigationDataUL.find('[data-id=' + parentId + ']').first().clone();
        subcategoryTitle.attr('data-parent', parentId);
        subcategoryTitle.removeAttr('data-id');
        subcategoryTitle.attr('id', 'title-' + parentId);
        subcategoryTitle.addClass('subcategoryTitle');
        
        Navigation_v2.wrapSubcategoryTitleAnchor(subcategoryTitle);
        
        if (level == 2) {
          if ($(childElements).length != 0) {
            $(Navigation_v2.level2_AllDepartments).find('ul').append(subcategoryTitle);
            $(Navigation_v2.level2_AllDepartments).find('ul').append(childElements);
          }
        } else if ($(childElements).length != 0) {
          $(Navigation_v2.level + level).find('ul').append(subcategoryTitle);
          $(Navigation_v2.level + level).find('ul').append(childElements);
        }

        let topCategoryId = $(Navigation_v2.navigationUI).find('li[id=' + parentId +']').attr('data-parent') !== undefined ? $(Navigation_v2.navigationUI).find('li[id=' + parentId +']').attr('data-parent') : 0 ;
        if (topCategoryId == "0") {
          topCategoryId = parentId;
        }
        Navigation_v2.showTopCatEspot(topCategoryId, isAncillary);
        if (level < Navigation_v2.maxLevel) {
          Navigation_v2.bindChildCategories(level, parentId);
        }
      }
    },

    wrapSubcategoryTitleAnchor: function(subcategoryTitle){
    	let subcategoryTitleAnchor = $(subcategoryTitle).find('a').clone();
        let subcategoryTitleAnchorWrapper = document.createElement('span');
        $(subcategoryTitleAnchorWrapper).attr('role', 'heading');
        $(subcategoryTitleAnchorWrapper).attr('aria-level', '2');
        $(subcategoryTitle).find('a').remove();
        $(subcategoryTitle).append($(subcategoryTitleAnchorWrapper).append($(subcategoryTitleAnchor)));
    },

    fillPhoneChildData: function(level, parentId) {
      let phoneSufix = '-phone';
      let subCategories = Navigation_v2.$navigationDataUL.find('[data-parent=' + parentId + ']')
      if(subCategories.length == 0) {
        subCategories = $('[data-parent="' + parentId + '"]')
      }
      let childElements = parentId % 1 === 0 ? subCategories.clone() : Navigation_v2.$navigationDataUL.find('[data-parent^=' + parentId + ']').clone();
      Navigation_v2.addIdAttributeToElements(childElements);
      let parentElementId = Navigation_v2.level + (level - 1) + phoneSufix;
      let isAncillary = Navigation_v2.isAncillaryElementSelected(parentId);

      if ($(Navigation_v2.level + level + phoneSufix).length == 0) {
        Navigation_v2.recreatePhoneLevelHTMLStructure(level, parentElementId);
      }

      $(Navigation_v2.level + level + phoneSufix).prepend(childElements);
      Navigation_v2.addAllSubcategoryLink(level, parentId);

      let topCategoryId = Navigation_v2.$navigationDataUL.find('li[data-id=' + parentId +']').attr('data-parent') !== undefined ? Navigation_v2.$navigationDataUL.find('li[data-id=' + parentId +']').attr('data-parent') : 0 ;
      if (topCategoryId == "0" || topCategoryId == "ancillary_0") {
        topCategoryId = parentId;
      }

      Navigation_v2.showTopCatEspotForPhone(level, topCategoryId, isAncillary);

      Navigation_v2.toggleSubCategoryElements(true);

      if (level < Navigation_v2.maxPhoneLevel) {
        Navigation_v2.bindPhoneChildCategories(level);
      }
    },

    showTopCatEspot: function(parent, isAncillary) {
      let parentEspot = Navigation_v2.$navigationDataUL.find('[data-espot-parent=' + parent + ']').clone();
      // replacing data-img-src for all the li image nodes 
      let imgSrcRegExp = new RegExp('data-img-src', 'g');
      parentEspot.each(function() {
        $(this).html($(this).html().replace(imgSrcRegExp, 'src'));
       
        if(isGRSMegaMenuEnabled) {
          $(this).find('a').attr('tabindex', '0');
          $(this).find('a').first().on('keydown', function(event) {
            if (event.shiftKey && event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
              event.preventDefault();
              if ($("#subcategory-level3").length) {
                $("#subcategory-level3").find('a').last().focus();
              } else if ($("#subcategory-level2").length) {
                $("#subcategory-level2").find('a').last().focus();
              }
            }
            if(event.keyCode === Navigation_v2.KEYCODES.ESC_KEY) {
              event.preventDefault();
              const parentElement = document.getElementById(parent);
              Navigation_v2.handleEspotFocus(parentElement);
            }
          });

          $(this).find('a').last().on('keydown', function(event) {
            if (!event.shiftKey && event.keyCode === Navigation_v2.KEYCODES.TAB_KEY) {
              event.preventDefault();
              if (document.getElementById("subcategory-level3")) {
                const allLevel3Categories = document.getElementById("subcategory-level3").querySelectorAll('li')
                if(allLevel3Categories.length > 1) {
                  const firstLevel3Element = allLevel3Categories[1];
                  const firstLevel3ElementId = firstLevel3Element.getAttribute('data-parent');
                  const nextLevel2ElementToFocus = document.getElementById("subcategory-level2").querySelector(`#l2_${firstLevel3ElementId}`);
                  if (nextLevel2ElementToFocus) {
                    nextLevel2ElementToFocus.focus();
                    window.wioEventBus.publish('clearLevel3Categories')
                  }
                  else {
                    let parentElement = document.getElementById(Number(parent) + 1);
                    if(!parentElement) {
                        //This is the last element of top category so keep it focused
                      parentElement = document.getElementById(parent);
                    }
                    Navigation_v2.handleEspotFocus(parentElement);
                  }
                }
              }
              else {
                let parentElement = document.getElementById(Number(parent) + 1);
                if(!parentElement) {
                    //This is the last element of top category so keep it focused
                  parentElement = document.getElementById(parent);
                }
                Navigation_v2.handleEspotFocus(parentElement);
              }
            }
            if(event.keyCode === Navigation_v2.KEYCODES.ESC_KEY) {
              event.preventDefault();
              parentElement = document.getElementById(parent);
              Navigation_v2.handleEspotFocus(parentElement);
            }
          }
        );
        }
      });
      if (isAncillary) {
        $(Navigation_v2.level2_AncillaryDepartments).append(parentEspot);
      } else {
        for (i = 2; i <= Navigation_v2.maxLevel; i++) {
          if (i == 2) {
            if ($(Navigation_v2.level2_AllDepartments).find('ul').is(':empty')) {
              $(Navigation_v2.level2_AllDepartments).find('ul').append(parentEspot);
            }
          } else {
             if ($(Navigation_v2.level + i).find('ul').is(':empty')) {
              $(Navigation_v2.level + i).find('ul').append(parentEspot);
              break;
            }
          }
        }
      }
    },

    handleEspotFocus: function(parentElement) {
      if (parentElement) {
        const childElement = parentElement.querySelector('a');
        if (childElement) {
          childElement.focus();
          window.wioEventBus.publish('clearSubcategory')
        }
      }
    },

    showTopCatEspotForPhone: function(level, parent, isAncillary) {
      let parentEspot = Navigation_v2.$navigationDataUL.find('[data-espot-parent=' + parent + ']').clone();
      // replacing data-img-src for all the li image nodes 
      let imgSrcRegExp = new RegExp('data-img-src', 'g');
      parentEspot.each(function() {
    	  $(this).html($(this).html().replace(imgSrcRegExp,'src'))
      });
      for (i = 2; i <= Navigation_v2.maxPhoneLevel; i++) {
        $(Navigation_v2.level + i +'-phone').find('li[data-espot-parent]').each(function(){
           $(this).remove();
        });
      }

      $(Navigation_v2.level + level +'-phone').append(parentEspot);
    },

    // espotContainsSubcategoryLinks: function(espotTopCategoryId) {
    //   return $('[data-espot-parent="' + espotTopCategoryId +'"]').find('.category-level-2').length !== 0;
    // },

    populateNavigationDataWithEspotSubcategoryLinks: function(espotTopCategoryId) {
      Navigation_v2.$navigationDataUL.find('[data-espot-parent="' + espotTopCategoryId +'"]').each( function() {
        if ($(this).find('.category-level-2').length !== 0) {
          $(this).find('.category-level-2').each( function(cat2Index) {
            if ($(this).find('.category-level-3').length !== 0) {
              //creating category-level-2 navigation data li elements from espot content
              let categoryLevel2Title = $(this).find('li').first().contents();
              let cat2ElementIdAttr = espotTopCategoryId + '-cat2-' + cat2Index;
              Navigation_v2.createLiElementInNavigationData(espotTopCategoryId, cat2ElementIdAttr, categoryLevel2Title);

              //creating category-level-3 navigation data li elements from espot content
              $(this).find('.category-level-3').find('li').each( function(cat3Index) {
                let categoryLevel3Link = $(this).contents();
                let cat3ElementIdAttr = espotTopCategoryId + '-cat3-' + cat3Index;
                Navigation_v2.createLiElementInNavigationData(cat2ElementIdAttr, cat3ElementIdAttr, categoryLevel3Link);
                $(this).remove();
              })
            }
          })
        }
        if($(this).text().trim().length === 0) {
          $(this).remove();
        }
      })
    },
    
    populateAncillaryNavigationDataWithEspotSubcategoryLinks: function(espotTopCategoryId) {
      Navigation_v2.$navigationDataUL.find('[data-espot-parent="' + espotTopCategoryId +'"]').each( function() {
        var $olEle = $(this).find('ol');
        if ($olEle.length !== 0) {
          $olEle.each( function(levelIndex) {
            var $liSubItemEle = $(this).find('li.sub-item');
            var $liNotSubItemEle = $(this).find('li:not(.sub-item)');

            //level-2 navigation data li elements from espot content
            if ($liNotSubItemEle.length !== 0) {
              let categoryLevel2Title = $liNotSubItemEle.contents();
              let cat2ElementIdAttr = espotTopCategoryId + '-level2-' + levelIndex;
              Navigation_v2.createLiElementInNavigationData(espotTopCategoryId, cat2ElementIdAttr, categoryLevel2Title);

              //level-3 navigation data li elements from espot content
              if ($liSubItemEle.length !== 0) {
                $liSubItemEle.each( function(level3Index) {
                  let categoryLevel3Link = $(this).contents();
                  let cat3ElementIdAttr = espotTopCategoryId + '-level3-' + levelIndex + '-' + level3Index;
                  Navigation_v2.createLiElementInNavigationData(cat2ElementIdAttr, cat3ElementIdAttr, categoryLevel3Link);
                  $(this).remove();
                })
              }
            } else {
              if ($liSubItemEle.length !== 0) {
                $liSubItemEle.each( function(level2Index) {
                  let categoryLevel2Link = $(this).contents();
                  let cat2ElementIdAttr = espotTopCategoryId + '-level2-' + levelIndex + '-' + level2Index;
                  Navigation_v2.createLiElementInNavigationData(espotTopCategoryId, cat2ElementIdAttr, categoryLevel2Link);
                  $(this).remove();
                })
              }
            }
            $(this).remove();
          })
        }
        if($(this).text().trim().length === 0) {
          $(this).remove();
        }
      })
    },

    addParentSubcategoryLink: function(elementId) {
    	
      let parentSubcategoryElement = Navigation_v2.$navigationDataUL.find('[data-id=' + elementId + ']').clone();
      Navigation_v2.addIdAttributeToElements(parentSubcategoryElement);
      parentSubcategoryElement.attr('data-parent-subcategory', 'parent-subcategory-link');
      parentSubcategoryElement.attr('tabindex', '-1');
      parentSubcategoryElement.on('keydown click' , function(e) {
          if(e.type == 'click' || e.which === Navigation_v2.KEYCODES.ENTER_KEY) {
            let id = this.id;
	    	  Navigation_v2.emptySubCategoryElements(1);
	          Navigation_v2.addSubcategoryTitle(this.innerText);
	          Navigation_v2.addAllDepartmentsLink(id);
	          if(e.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	        	  $('#all-departments-link').focus();
              }
	          Navigation_v2.fillPhoneChildData(2, id);
          }
      });
      $('#level1-phone').prepend(parentSubcategoryElement);
    },

    addSubcategoryTitle: function(subcategoryTitle) {
      jQuery('<li/>', {
        id: 'all-subcategory-title',
        class: 'selectedSubcategoryTitle',
        text: subcategoryTitle
      }).prependTo('#level1-phone');
    },

    addAllSubcategoryLink: function(level, elementId) {
      let allSubcategoryElement = Navigation_v2.$navigationDataUL.find('[data-id=' + elementId + '] a').clone();
      allSubcategoryElement.attr('all-subcategory-link', 'true');
      allSubcategoryElement.addClass('clickable-link');
      let subcategoryTitle = allSubcategoryElement.text();
      allSubcategoryElement.text('All ' + subcategoryTitle);

      $(Navigation_v2.level + level + '-phone').prepend(allSubcategoryElement);
    },

    addAllDepartmentsLink: function(parentId) {
      Navigation_v2.allDepartmentsParentId = parentId;	
      jQuery('<li/>', {
        id: 'all-departments-link',
        text: "All Departments",
        tabindex: -1,
      }).prependTo('#level1-phone');
      $('#all-departments-link').on('click keydown', function(event) {
    	if(event.type == 'click' || event.which === Navigation_v2.KEYCODES.ENTER_KEY){
	        Navigation_v2.emptySubCategoryElements(1, true);
	        $(Navigation_v2.navigationPhoneUI).hide();
	        Navigation_v2.toggleNavigation(true, event);
	        if(event.which === Navigation_v2.KEYCODES.ENTER_KEY) {
	        	$('#level1-all-departments-phone').find('#'+Navigation_v2.allDepartmentsParentId + ' a').focus();
            }
    	}
      })
    },

    addChevronForSelectedLink: function(element) {
      let elementName = $(element).text();
      let spanElement = jQuery('<button/>', {
        id: 'span-' + $(element).attr('id'),
        class: 'offscreen',
        tabindex: '0',
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
        text: elementName + ' ' + messages.MENU
      });
      let iElement = jQuery('<i/>', {
        id: 'arrow-' + $(element).attr('id'),
        class: 'co-arrow-right navigation-v2-arrow pull-right',
        tabindex: '0',
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
      });

      spanElement.appendTo(iElement);
      iElement.appendTo(element);
    },

    createLiElementInNavigationData: function (dataParentAttr, idAttr, content) {
      var newListItem = document.createElement( "li" );
      newListItem.setAttribute('data-parent', dataParentAttr)
      newListItem.setAttribute('data-id', idAttr)
      newListItem.appendChild(content[0]);
      Navigation_v2.tempFragment.appendChild(newListItem);
    },

    removeChevronFromAllLinks: function() {
      $(Navigation_v2.navigationUI + ' i').each(function() {
        $('.navigation-v2-arrow').remove();
      })
    },

    recreatePhoneLevelHTMLStructure: function(level, parentElementId) {
      jQuery('<div/>', {
        id: 'level' + level + '-phone',
        class: 'col-xs-12 navigation-category-level panelPaddingLeft30'
      }).appendTo(parentElementId);
    },

    alignSubMenus: function() {
    	
    	let maxLev = Navigation_v2.maxLevel;
    	
    	for (j = 1; j <= maxLev; j++) {
    		$(Navigation_v2.level + j).removeAttr("style");
    	}

    	for (j = 2; j <= maxLev; j++) {
    		if ($(Navigation_v2.level + j).height() > 0) {
    			var h1 = $(Navigation_v2.level + (j-1)).outerHeight();
    			if ($(Navigation_v2.level + j).height() < h1)
    				$(Navigation_v2.level + j).attr("style", "height: " + h1 + "px !important");
    			if ($(Navigation_v2.level + j).height() > h1) {
    				var h2 = $(Navigation_v2.level + j).outerHeight();
    				for (k = j; k > 0; k--) {
    					$(Navigation_v2.level + k).attr("style", "height: " + h2 + "px !important");
    				}
    			}
    		}
    	}	
    },

    /**
     * this function enables/disables <a> tag default behaviour depending on the value of aria-expanded attribute
     * @param  level - panel level

     */
    toggleAnchorTagForTablet: function(level) {
      $(Navigation_v2.level + level).find('a').each( function() {
        let parentLiElementId = $(this).parent().attr('id');
        if (parentLiElementId !== undefined && parentLiElementId !== false) {
          if(Navigation_v2.categoryHasChildData(parentLiElementId)) {
            if($(this).attr('aria-expanded') === 'true') {
              $(this).removeClass('disabled');
            } else {
              $(this).addClass('disabled');
            }
          }
        }
      });
    },

    toggleSubCategoryElements: function(isPhone) {
      let maxLev = isPhone ? Navigation_v2.maxPhoneLevel : Navigation_v2.maxLevel;
      let phoneSufix = isPhone ? '-phone' : '';
      for (i = 1; i <= maxLev; i++) {
        if (i == 1) {
          if ($(Navigation_v2.level1_AllDepartments + phoneSufix).find('li').length == 0) {
            $(Navigation_v2.level1_AllDepartments + phoneSufix).hide();
          } else {
            $(Navigation_v2.level1_AllDepartments + phoneSufix).show();
            $('#phone-divider').show();
          }
          if ($(Navigation_v2.level1_AncillaryDepartments + phoneSufix).html().length == 0) {
            $(Navigation_v2.level_AncillaryDepartments + phoneSufix).hide();
          } else {
            $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).show();
          }
        } else if (i == 2) {
          if (isPhone) {
            let level2Element = Navigation_v2.level + i + phoneSufix;
            let level3Element = Navigation_v2.level + (i+1) + phoneSufix; 
            if ($(level3Element).length == 0 || $(level3Element).html().length == 0) {
              if ($(':not([id^="level3-phone"])', level2Element).length == 0) {
                $(Navigation_v2.level + i + phoneSufix).hide();
              } else {
                $(Navigation_v2.level + i + phoneSufix).show();
              }
            }
          } else {
            if ($(Navigation_v2.level2_AllDepartments).find('li').length == 0) {
              $(Navigation_v2.level2_AllDepartments).hide();
              $(Navigation_v2.level + i).hide();
            } else {
              $(Navigation_v2.level2_AllDepartments).show();
              $(Navigation_v2.level + i).show();
              
              if (!Navigation_v2.isTabletView()) {
            	  Navigation_v2.alignSubMenus();
              }
              
            }
            if ($(Navigation_v2.level2_AncillaryDepartments).html().length == 0) {
              $(Navigation_v2.level2_AncillaryDepartments).hide();
            } else {
              $(Navigation_v2.level2_AncillaryDepartments).show();
              $(Navigation_v2.level + i).hide();
            }
          }
        } else {
          if ($(Navigation_v2.level + i + phoneSufix).find('li').length == 0) {
            $(Navigation_v2.level + i + phoneSufix).hide();
          } else {
            $(Navigation_v2.level + i + phoneSufix).show();
          }
        }
        if(Navigation_v2.isTabletView() && i < (maxLev - 1)) {
          Navigation_v2.toggleAnchorTagForTablet(i);
        }
      }
    },

    emptySubCategoryElements: function(level, isPhone) {
      let isPhoneDevice = isPhone || Navigation_v2.isPhoneView();
      let maxLev = isPhoneDevice ? Navigation_v2.maxPhoneLevel : Navigation_v2.maxLevel;
      let phoneSufix = isPhoneDevice ? '-phone' : '';
      for (i = level; i <= maxLev; i++) {
        if (i == 1) {
          $(Navigation_v2.level1_AllDepartments + phoneSufix).find('ul').empty();
          $(Navigation_v2.level1_AllDepartments + phoneSufix).hide();
          $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).empty();
          $(Navigation_v2.level1_AncillaryDepartments + phoneSufix).hide();
          if (isPhoneDevice) {
              $('[data-parent-subcategory="parent-subcategory-link"]').remove();
              $('#all-departments-link').remove();
              $('.selectedSubcategoryTitle').remove();
          }
        } else if (i == 2) {
          if (isPhoneDevice) {
            $('#phone-divider').hide();
            $('#level3-phone').empty();
            $(':not([id^="level3-phone"])', '#level2-phone').remove();
            $('#level2-phone').hide();
          } else {
            $(Navigation_v2.level2_AllDepartments).find('ul').empty();
            $(Navigation_v2.level2_AllDepartments).hide();
            $(Navigation_v2.level2_AncillaryDepartments).empty();
            $(Navigation_v2.level2_AncillaryDepartments).hide();
          }
        } else {
          if ($(Navigation_v2.level + i + phoneSufix).find('ul').length != 0) {
            $(Navigation_v2.level + i + phoneSufix).find('ul').empty();
          }
          $(Navigation_v2.level + i).hide();
        }
      }
    },

    showOverlayWhenMenuDisplayed: function() {
      $('#tiles-body-attribute').addClass('navigation-v2-disable-links');
      $('#navigation-overlay-div-element').show();
    },

    hideOverlayAndCloseMenu: function(isPhone) {
      let elementPanel = isPhone ? Navigation_v2.navigationPhoneUI : Navigation_v2.navigationUI;
      $('#navigation-overlay-div-element').hide();
      $('#tiles-body-attribute').removeClass('navigation-v2-disable-links');

      Navigation_v2.emptySubCategoryElements(1, isPhone);
      $(elementPanel).hide();
      $('#navigation-dropdown').attr('aria-expanded','false');
      $(Navigation_v2.menuIconMobile).attr('aria-expanded', 'false');
      window.wioEventBus.publish('clearSubcategory');
    },

    isAncillaryElementSelected: function(elementId) {
      return elementId !== undefined && elementId.includes("Ancillary") ? true : false ;
    },

    keepParentLinksHighlighted: function(level, elementId) {
      let currentElement = $(Navigation_v2.navigationUI + ' #' + elementId);
      let currentElementId = elementId;
      let currentLevel = level;
      while (currentElement.length != 0) {
        $(Navigation_v2.level + currentLevel).find('li:not(#' + currentElementId + ')').each( function() {
          $(this).removeClass('selectedLinkBold');
        });
        if (!Navigation_v2.isAncillaryElementSelected(elementId) && currentLevel < 3) {
          currentElement.addClass('selectedLinkBold');
        }
        currentLevel = --currentLevel;
        currentElementId = currentElement.attr('data-parent');
        currentElement = $(Navigation_v2.navigationUI + ' #' + currentElementId);
      }
    },

    initNavPopovers : function (){
      //removal of nav-flyout class and Home_Ancillary ids from navigation_v2_data elements
      //in order to skip them in the next loop
      Navigation_v2.$navigationDataUL.find('[data-parent="ancillary_0"] [id^="Home_Ancillary"]').each(function() {
        let newId = 'data_' + $(this).attr('id');
        $(this).removeClass('nav-flyout');
        $(this).attr('id', newId);
      })

      Navigation_v2.$navigationWidgetEle.find('.nav-flyout').each(function(){
        let _this = $(this);
        let flyoutId = _this.data('flyout');
        console.log('Init Nav Flyout' + flyoutId);
        flyoutId = flyoutId ? '#' + flyoutId : '';

        if(flyoutId != null && flyoutId != ''){
          let containerId = flyoutId + '-container';
          Navigation_v2.hover_click_popover_link_and_button(_this, flyoutId, false);
          let rule = "{width:" + _this.data('width') + "px}";
          COSTCO.util.setStyleRule(containerId,rule);
        }
      })

      Navigation_v2.$navigationWidgetEle.find('[id^="button_Home_Ancillary"]').each(function(i) {
    	  let _this = $('#popover_for_'+this.id);
          let ancillaryLinkElement = $('#' + _this.attr('data-emsName'));
          let flyoutId = ancillaryLinkElement.data('flyout') ? '#' + ancillaryLinkElement.data('flyout') : '';
          let buttonSpanText = $('#Home_Ancillary_' + i).text();
          $('#'+ this.id + ' span').text(buttonSpanText);
          if(flyoutId != null && flyoutId != ''){
            let containerId = 'button_' + flyoutId + '-container';
            Navigation_v2.hover_click_popover_link_and_button(_this, flyoutId, true);
            let rule = "{width:" + _this.data('width') + "px}";
            COSTCO.util.setStyleRule(containerId,rule);
          }
    	  
        $('#'+this.id).on('keydown click', function(event){
        	if (event.which === Navigation_v2.KEYCODES.ENTER_KEY || event.type === "click") {
        		event.preventDefault();
        		if (($('#popover_for_'+this.id).has('.popover').length == 1)) {
        			$('#popover_for_'+this.id).popover('hide');
        		} else { 
        			$('#popover_for_'+this.id).popover("show");
        		}
        	}
        }); 
      })

      //added logic here to check if url is an external site per
      //same logic as in whiteList. Whitelist init does not apply to
      //any of the dropdown since they are not part of the dom on page init
      Navigation_v2.$navigationWidgetEle.find('.nav-flyout').on('click', 'a', function(e) {
        if(this.hostname && this.hostname != location.hostname
         && !this.href.match(/^(mailto|javascript)\:/) && this.href != ''
         && !COSTCO.whiteList.isOnWhiteList(this.hostname)){
          COSTCO.whiteList.createDialogBox(this.href);
          e.preventDefault();
        }
        //user want to click on the url inside the flyout not the parent link
        e.stopPropagation();
      });

      Navigation_v2.setKeyboardNavigationForAncillaryLinks();
    },

    hover_click_popover_link_and_button: function(selector, content, isArrowButton) {
      let hoverClickElement = $(selector);
      let triggerEvent = 'hover';
      if (isArrowButton) {
    	  triggerEvent = 'manual';
      }
      hoverClickElement.popover({
          html: true,
          sanitize: false,
          animation: false,
          delay: {
            show: 200,
            hide: 200,
          },
          content: function() {
            return $(content).html();
          },
          container: selector,
          placement: 'bottom',
          trigger: triggerEvent,
        })
        .on('focus', function(e) {
          Navigation_v2.hideAllNavigationPopovers();
          Navigation_v2.hideOverlayAndCloseMenu(false);
        })
        // Adding listener to toggle the aria tags when popover shown/hidden
        .on('shown.bs.popover', function() {
          if($(this).prop("tagName")=="BUTTON" || this.id.startsWith("popover_for_button")){
          $(this).attr('aria-expanded', 'true');
          }
          
          $(this).find('.popover').addClass('top50pixels');
          // used to create ada attributes on popover
          let identifierString = this.id + '_id';
          $(this).find('.popover-content').attr('id', identifierString);
          
          $(this).removeAttr('aria-describedby');
          $(this).find('.popover').removeAttr('role');
          
          $('#'+ identifierString).find('li:first a').focus();
        })
        .on('hidden.bs.popover', function() {
        	if($(this).prop("tagName")=="BUTTON" || this.id.startsWith("popover_for_button")){
          $(this).attr('aria-expanded', 'false');
            }
        });
    },

    setKeyboardNavigationForAncillaryLinks: function() {
      Navigation_v2.$navigationWidgetEle.find('[id^="Home_Ancillary"]').on('focus', function(event) {
        Navigation_v2.$navigationWidgetEle.find('[id^="button_Home_Ancillary"]').addClass('hidden');
        $('#button_' +  this.id ).removeClass('hidden');
      })
    },

    hideAllNavigationPopovers: function() {
      Navigation_v2.$navigationWidgetEle.find('a[id^="Home_Ancillary"], button[id^="button_Home_Ancillary"]').popover('hide');
    }
  }

  if (typeof window.COSTCO == 'undefined'){
    window.COSTCO = new Object();
  }

  window.COSTCO.Navigation_v2 = Navigation_v2;
    return Navigation_v2;

});



// WEBPACK FOOTER //
// ./js/browse/navigation_v2.js